import { SagaIterator } from 'redux-saga';
import { LOGIN_PERFORM } from 'src/modules/login/actions/LoginActions';
import { REQUEST_ACCESS_SUBMIT } from 'src/modules/login/actions/RequestAccessActions';
import { UPDATE_USER_SETTINGS } from 'src/modules/login/actions/UserSettingsActions';
import { loginPerformSaga } from 'src/modules/login/sagas/loginPerformSaga';
import { requestAccessSubmitSaga } from 'src/modules/login/sagas/requestAccessSubmitSaga';
import { updateUserSettingsSaga } from 'src/modules/login/sagas/updateUserSettingsSaga';
import { takeLatest } from 'typed-redux-saga';

export function* loginSaga(): SagaIterator<void> {
  yield* takeLatest(LOGIN_PERFORM.isRequest, loginPerformSaga);
  yield* takeLatest(REQUEST_ACCESS_SUBMIT.is, requestAccessSubmitSaga);
  yield* takeLatest(UPDATE_USER_SETTINGS.is, updateUserSettingsSaga);
}
